import React, { useState } from "react";
import ListItem from "./ListItem";
import TaskDetails from "./TaskDetails";

function List({ tasks, colourBlindMode }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState({
        id: 0,
        taskName: "",
        taskType: "",
        taskStoryPoint: "",
        taskTag: [],
        taskPriority: "",
        taskDescription: "",
        taskStatus: "NotStarted",
        taskStage: "Planning",
        taskAssignee: "",
        taskInSprint: false,
    });

    // function to open the modal for a specific item
    const openModal = (item) => {
        setSelectedItem(item);
        setIsModalOpen(true);
    };

    // function to close the modal
    const closeModal = () => {
        setSelectedItem(null);
        setIsModalOpen(false);
    };

    return (
        <div className= "mb-[30px]">
            {tasks.map((task, index) => (
                <ListItem colourBlindMode={colourBlindMode} task={task} openModal={openModal} />
            ))}
            {isModalOpen && (
                <TaskDetails colourBlindMode={colourBlindMode} task={selectedItem} closeModal={closeModal} />
            )}
        </div>
    );
}

export default List;
